import { create } from 'zustand'

import * as dashboardApi from '../api/dashboard.api'

export const useSalesDashboardStore = create((set, get) => ({
  campaignLeads: null,
  conversionRate: null,
  ordersClosed: null,
  ordersLost: null,
  leadsManagement: null,
  leadsNotFollowedUp: [],
  target: 0,
  achievement: 0,

  isLoading: true,
  hasLoaded: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchDashboard: async (period = 'all', customRange = {}) => {
    const { hasLoaded } = get()

    set({
      isLoading: !hasLoaded,
      error: null,
    })

    try {
      const params = { period }
      if (period === 'custom' && customRange?.startDate)
        params.startDate = customRange.startDate
      if (period === 'custom' && customRange?.endDate)
        params.endDate = customRange.endDate

      const response = await dashboardApi.getSalesDashboard(params)
      const payload = response?.data ?? {}

      set({
        campaignLeads: payload?.campaignLeads || null,
        conversionRate: payload?.conversionRate || null,
        ordersClosed: payload?.ordersClosed || null,
        ordersLost: payload?.ordersLost || null,
        leadsManagement: payload?.leadsManagement || null,
        leadsNotFollowedUp: payload?.leadsNotFollowedUp || [],
        target: payload?.target ?? payload?.ordersClosed?.target ?? 0,
        achievement:
          payload?.achievement ?? payload?.ordersClosed?.achievement ?? 0,
        isLoading: false,
        hasLoaded: true,
        error: null,
      })

      return response
    } catch (error) {
      const message = error?.message || 'Failed to load sales dashboard'

      set({
        isLoading: false,
        error: message,
      })
    }
  },
  removeLeadFromFollowedUp: (leadId) => {
    set((state) => ({
      leadsNotFollowedUp: state.leadsNotFollowedUp.filter(
        (lead) => String(lead._id) !== String(leadId),
      ),
    }))
  },
}))
